export class EncryptRequestPayload {
  username: string;
  timestamp: number;
  clientId?: number;
}



// WEBPACK FOOTER //
// ./src/app/services/user/payload/encrypt-request.payload.ts